import clsx from "clsx"
import { FC } from "react"
import style from "./Spinner.module.css"

type SpinnerSize = "s" | "m"

type SpinnerProps = {
  size?: SpinnerSize
}

export const Spinner: FC<SpinnerProps> = ({ size = "s" }) => {
  return (
    <div
      data-name={"spinner"}
      className={clsx(style.spinner, style[size])}
    />
  )
}
